import { render } from "./Language.vue?vue&type=template&id=573ebfa6&scoped=true"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"

import "./Language.vue?vue&type=style&index=0&id=573ebfa6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-573ebfa6"

export default script